import { Component, Inject, OnInit, ChangeDetectorRef, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RequestService, LayoutUtilsService, LoaderService } from '../../../shared/services';
import { urlSafeBase64Encoding, isValidHttpUrl, getOtherImage, deepEqual, openCenteredPopup, isValidCustomUrl, SITE_MAPPING_CAMERA_TYPES } from '../../../shared/helpers';
import { FormControl, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { fromEvent, BehaviorSubject, merge, Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';

import { CustomSelectDialogComponent } from '../../../shared/components/custom-select-dialog/custom-select-dialog.component';
import { CustomTagsComponent } from '../../../shared/components/custom-tags/custom-tags.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { ModalGalleryDialogComponent } from '../../../shared/components/custom-gallery-dialog/custom-gallery-dialog.component';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomCreateTableDialogComponent } from '../custom-create-table-dialog/custom-create-table-dialog.component';
import { CustomSelectNewComponent } from '../custom-select-new/custom-select-new.component';
import { CustomDateTimeComponent } from '../custom-datetime/custom-datetime.component';
import { SmartMapComponent } from '../smart-map/smart-map.component';
import { Router } from '@angular/router';
import { SignalingService } from '../../services/signaling.service';
const MY_FORMATS = {
  parse: {
    dateInput: ['YYYY/MM/DD'],
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY MMMM',
  },
};
declare var rrule: any;

export class MyDialogErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export interface DialogData {
  dataType: string;
  dataTypeTitle: string;
  dataTypeSingleTitle: string;
  title: string;
  data: any;
  action: string;
  profile: boolean;
  modalSetting: any;
  confirmData: any;
  focusField: string;
  _locale?: string;
}

@Component({
  selector: 'app-dialog-modal',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class ModalDialogComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  public errorMessage: string = '';
  public selectedUser: any;
  public changeOccured: boolean = false;
  public apiCallSubscription: any = undefined;
  public selectedUserSubscription: any = undefined;
  private organization: any = undefined;
  public settingOrgObject = undefined;
  public focusField = undefined;
  public enableSiteMapping: boolean = false;
  public customError: any = {};
  // public taretFocusField = undefined;
  public isPasswordOrgRequired: boolean = false;
  public hasRolesOrgRequired: boolean = false;
  public enableSurveillance: boolean = false;
  public adminId: string = environment.customKeys.rolePrefectureCommanders;
  public vertical = environment.orgType;
  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public loaded: boolean = false;
  public loading: boolean = false;
  public sendEmail: boolean = true;
  public hasFormErrors: boolean = false;
  public esMatcher = new MyDialogErrorStateMatcher();
  public isSubmitted: boolean = false;
  public controllerData = {};
  public metaFieldSetting = undefined;
  public originalData = undefined;
  public isProfile: boolean = false;
  public lazyLoadSafari: boolean = false;
  public age = 0;
  public yearsInService: any = '';
  public ruleText = '';
  public defaultRuleData: any = {
    repeats: "daily",
    interval: 1,
    end: "after",
    count: 1
  };
  public fieldsObject: any = {};
  public orderOfExhibit: number[] = [];
  public allowedExtensions: string[] = ['jpeg', 'jpg', 'png', 'gif'];
  public allowedAcceptExtensions: string = 'image/jpg,image/jpeg,image/png,image/gif';
  public selectedLocaleLang: string = 'en';

  public filteredCaseTypes: string[] = [];

  years: number[] = [];
  selectedYear = {};

  public action = undefined;
  public baseImageGeo = '';
  public baseImageGeoSet = {};
  public baseImageGeoSetDegrees = [0, 45, 90, 135, 180, 225, 270, 315];
  @ViewChildren(CustomDateTimeComponent) customDateTimeComponent!: QueryList<CustomDateTimeComponent>;
  @ViewChildren('customTag') customTags: QueryList<CustomTagsComponent>;
  @ViewChild('fileselect') fileselect: ElementRef;
  @ViewChild('personForm') personForm: NgForm;
  // @ViewChild('currentDialogMap') currentDialogMap: GoogleMapsComponent;
  @ViewChild('dialogMap') dialogMap: SmartMapComponent;
  @ViewChild('caseTypeSelect') caseTypeSelect: CustomSelectNewComponent;
  constructor(private translate: TranslateService, private router: Router, private changeDetectorRefs: ChangeDetectorRef,
    private requestService: RequestService, public dialog: MatDialog, private signalingService: SignalingService,
    private layoutUtilsService: LayoutUtilsService, private loaderService: LoaderService,
    public dialogRef: MatDialogRef<ModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    //console.log('DialogData', data);

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      this.lazyLoadSafari = true;
    }
    if (!this.data.dataTypeSingleTitle) {
      this.data.dataTypeSingleTitle = this.data.dataTypeTitle;
    }
    if (data && data.profile) {
      this.isProfile = data.profile;
    }
    if (data && data.focusField) {
      this.focusField = data.focusField;
    }
    if (data && data.action) {
      this.action = data.action;
    }
  }
  ngOnInit() {
    this.selectedLocaleLang = this.getSelectedLocaleLang();
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1900; year--) {
      this.years.push(year);
    }
    // Org settings must be applied before buildSetting(). Camera metadata is
    // often cached, so getMetaData can callback synchronously while
    // enableSiteMapping is still the default false.
    this.applyOrganizationSettings(this.requestService.pageOrganization.getValue());
    this.subscriptions.push(
      this.requestService.pageOrganization.subscribe((data) => {
        if (data) {
          this.applyOrganizationSettings(data);
          if (this.loaded && ['camera', 'cameragroup'].includes(this.data.dataType)) {
            this.cleanFieldsMeta();
          }
          // if (data.hasOwnProperty('settings')) {
          //   this.settingOrgObject = data.settings;
          // }
          // if (data.hasOwnProperty('stellarPasswordRequired')) {
          //   this.isPasswordOrgRequired = data.stellarPasswordRequired;
          // }
          // let exhibitorTotal = 1;
          // if (this.organization.exhibitorsCount) {
          //   exhibitorTotal = this.organization.exhibitorsCount
          // }
          // this.orderOfExhibit = Array(exhibitorTotal).fill(1).map((x, i) => i + 1);
        }
      })
    );
    this.subscriptions.push(
      this.requestService.currentUserSubject.subscribe((data) => {
        if (data) {
          this.selectedUser = data;
          this.isAdmin = this.requestService.isUserRoleAdmin();
          this.isSuperAdmin = this.requestService.isUserRoleSuperAdmin();

          // if (this.data.dataType === 'case') {
          //   this.fetchCaseTypes();
          // }
          this.buildSetting();
        }
      })
    );
  }
  private applyOrganizationSettings(org: any): void {
    if (!org) {
      return;
    }
    this.organization = org;
    const settings = this.requestService.getSettings(org);
    this.enableSurveillance = settings.enableSurveillance || false;
    this.enableSiteMapping = settings.enableSiteMapping || false;
    this.hasRolesOrgRequired = (org.roleCount && org.roleCount > 0);
  }

  private getSelectedLocaleLang(): string {
    return (
      this.data?._locale ||
      this.requestService?.lang ||
      this.translate?.currentLang ||
      this.translate?.defaultLang ||
      'en'
    );
  }
  ngOnDestroy() {
    this.data.data = {};
    this.subscriptions.forEach(el => el.unsubscribe());
    if (this.apiCallSubscription) {
      this.apiCallSubscription.unsubscribe();
    }
  }
  public checkDisabled(value) {
    if (this.settingOrgObject && this.settingOrgObject.web && this.settingOrgObject.web.topBar) {
      if (this.settingOrgObject.web.topBar.disableSchedule && value === 'agenda') {
        return true;
      } else if (this.settingOrgObject.web.topBar.disableExhibitor && value === 'sponsors') {
        return true;
      } else if (this.settingOrgObject.web.topBar.disableResource && value === 'resources') {
        return true;
      } else if (this.settingOrgObject.web.topBar.disablePoster && value === 'posters') {
        return true;
      } else if (this.settingOrgObject.web.topBar.disableDirectory && value === 'book') {
        return true;
      }
    }
    return false;
  }
  // handlePaste(event: ClipboardEvent, colName): void {
  //   event.preventDefault();
  //   try {
  //     const pastedText = event.clipboardData?.getData('text') || '';
  //     this.data.data[colName] = pastedText;
  //     // Your paste event handling code here
  //   } catch (error) {
  //     console.error('Error in paste event handling:', error);
  //   }
  // }
  validateEmail(id, event: Event) {
    const input = event.target as HTMLInputElement;
    if (!this.fieldsObject.hasOwnProperty(id)) {
      this.fieldsObject[id] = {};
    }
    this.fieldsObject[id]['value'] = input.value;
    this.checkEmail(id, this.fieldsObject[id]['value']);
  }
  checkEmail(id, email: string) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailPattern.test(email)) {
      this.fieldsObject[id]['pattern'] = '';
    } else {
      this.fieldsObject[id]['pattern'] = 'Please enter a valid email address.';
    }
  }
  // public fetchCaseTypes(event = undefined) {
  //   let term = undefined;
  //   if (event) {
  //     term = (event.target as HTMLInputElement).value;
  //   }
  //   if (this.apiCallSubscription) {
  //     this.apiCallSubscription.unsubscribe();
  //   }
  //   this.apiCallSubscription = this.requestService.getCaseTypeList(term, (data, error) => {
  //     if (error) {
  //       // do nothing
  //     }
  //     if (data && data.results) {
  //       this.filteredCaseTypes = data.results.map((itm) => itm.case_type);
  //     }
  //   });
  // }
  private onCaseTypeSelection(id, event) {
    this.data.data[id] = event.option.value;
  }
  private buildSetting() {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.data.modalSetting.fields = [];

      let orgId = undefined;
      let lang = undefined;
      if (this.data.dataType === 'user') {
        orgId = this.requestService.orgId;
        lang = this.requestService.lang;
      }
      this.requestService.getMetaData(this.data.dataType, undefined, (data, error) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + error, this.translate.instant('Dismiss'));
        }
        this.loading = false;
        if (data) {
          let newFields = JSON.parse(JSON.stringify(data.results.fields));
          this.metaFieldSetting = this.buildMetaSetting(data.results, parent = undefined);
          let idx = 0;
          if (this.data.modalSetting.hasOwnProperty('customSettings')) {
            for (let fld of newFields) {
              if (this.data.modalSetting.customSettings.hasOwnProperty(fld.name)) {
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('visible')) {
                  newFields[idx]['visible'] = this.data.modalSetting.customSettings[fld.name].visible;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('enumDisabled')) {
                  newFields[idx]['enumDisabled'] = this.data.modalSetting.customSettings[fld.name].enumDisabled;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('disabled')) {
                  newFields[idx]['disabled'] = this.data.modalSetting.customSettings[fld.name].disabled;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('controller')) {
                  newFields[idx]['controller'] = this.data.modalSetting.customSettings[fld.name].controller;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('nullable')) {
                  newFields[idx]['nullable'] = this.data.modalSetting.customSettings[fld.name].nullable;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('options')) {
                  newFields[idx]['options'] = this.data.modalSetting.customSettings[fld.name].options;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('positive')) {
                  newFields[idx]['positive'] = this.data.modalSetting.customSettings[fld.name].positive;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('min')) {
                  newFields[idx]['min'] = this.data.modalSetting.customSettings[fld.name].min;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('max')) {
                  newFields[idx]['max'] = this.data.modalSetting.customSettings[fld.name].max;
                }
                if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('control')) {
                  newFields[idx]['control'] = this.data.modalSetting.customSettings[fld.name].control;
                  newFields[idx]['filters'] = this.data.modalSetting.customSettings[fld.name].filters;
                  newFields[idx]['nullable'] = this.data.modalSetting.customSettings[fld.name].required;
                  if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('blueprint')) {
                    newFields[idx]['blueprint'] = this.data.modalSetting.customSettings[fld.name].blueprint;
                  }
                } else if (this.data.modalSetting.customSettings[fld.name].hasOwnProperty('filters')) {
                  newFields[idx]['filters'] = this.data.modalSetting.customSettings[fld.name].filters;
                }
              } else if (this.hasRolesOrgRequired && ((this.data.dataType === 'user' && fld.name === 'role'))) {
                newFields[idx]['visible'] = true;
              }
              idx++;
            }
          }
          // console.log(newFields);
          this.prepareMetaDataFields(newFields);
          if (this.data.data.hasOwnProperty('_id')) {
            this.loadData();
          } else {
            this.data.data = this.getEmptyObject();
            this.cleanFieldsMeta();
            this.focusOn();
            this.loaded = true;
          }
        } else {
          console.log(this.translate.instant('Something is Wrong'));
        }
      }, orgId);
    }
  }
  prepareMetaDataFields(newFields) {
    this.applyOrganizationSettings(this.requestService.pageOrganization.getValue());
    if (this.data.dataType === 'camera') {
      this.applySiteMappingCameraTypeEnum(newFields);
    }
    if (this.data.dataType === 'cameragroup') {
      newFields.forEach(field => {
        if (field.name === 'cameras') {
          this.applySiteMappingCameraTypeFilter(field);
        }
      });
    }
    // filter 
    this.data.modalSetting.fields = newFields;
  }
  private applySiteMappingCameraTypeEnum(fields: any[] = this.data?.modalSetting?.fields): void {
    if (!Array.isArray(fields)) {
      return;
    }
    const restrictedTypes = this.enableSiteMapping ? [] : SITE_MAPPING_CAMERA_TYPES;
    fields.forEach((field) => {
      if (field?.name === 'camera_type' && Array.isArray(field.enum)) {
        field.enum.forEach((enumItem) => {
          enumItem.hide = restrictedTypes.includes(enumItem.value);
        });
      }
    });
  }
  focusOn() {
    if (this.focusField) {
      setTimeout(() => {
        const elements = document.getElementsByName(this.focusField);
        if (elements && elements.length > 0) {
          const element = elements[elements.length - 1] as HTMLInputElement;
          if (element) {
            element.focus();
          }
        }
      }, 1000);
    }
  }
  buildMetaSetting(data, parent = undefined) {
    let dataObject = {};
    // let tabObject = [];
    for (let col of data.fields) {
      if (((col.editable || !col.generated) && col.type !== 'object' && col.type !== 'table') || (col['name'] === 'age' && this.data.dataType === 'user') || (col['name'] === 'years_in_service' && this.data.dataType === 'user')) {
        if (parent) {
          col['inputName'] = parent + col['name'];
        }
        dataObject[col.name] = col;
      } else if (col.type === 'object') {
        dataObject[col.name] = this.buildMetaSetting(col);
      }
      else if (col.type === 'table') {
        dataObject[col.name] = col;
      }
    }
    return dataObject;
  }
  public loadData() {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      let dataId = this.data.data['_id'];
      if (this.data.modalSetting.hasOwnProperty('useOrgId')) {
        dataId = dataId + '/' + this.requestService.orgId;
      }
      this.requestService.getSingleData(this.data.dataType, dataId, (data, error) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + error, this.translate.instant('Dismiss'));
        }
        if (data) {
          this.data.data = this.getCleanDataObject(data.results);
          // if (this.data.data.hasOwnProperty('dob') && this.data.dataType === 'user') {
          //   let birthdate = new Date(this.data.data['dob']);
          //   this.calculateAge(birthdate);
          // }
          if (this.data.dataType === 'user') {
            if (this.data.data.hasOwnProperty('year-started')) {
              let yearInService = new Date(this.data.data['year-started']);
              // this.setYearServiceAttribute('year-started', yearInService.getFullYear());
              this.calculateYearInService(yearInService);
            }
            if (this.data.data.hasOwnProperty('dob')) {
              let dob = new Date(this.data.data['dob']);
              this.setYearAttribute('dob', dob.getFullYear());
              // this.calculateYearInService(yearInService);
            }
          }
          // if (this.data.dataType === 'event') {
          //   if (this.data.data.isRecurrence && this.data.data.recurrence) {
          //     this.setRuleText();
          //   }
          //   if (this.data.data.attendees) {
          //     this.data.data['attendeesId'] = this.data.data.attendees.map((itm) => {
          //       return itm._id;
          //     })
          //   }
          // }
          this.originalData = JSON.parse(JSON.stringify(this.data.data));
          this.cleanFieldsMeta();
          this.focusOn();
          this.loaded = true;
        }
        this.loading = false;
      });
    }
  }
  private getCleanDataObject(currentObject) {
    let newObj = currentObject;
    for (let col of this.data.modalSetting.fields) {
      if ((col.type === 'datetime' || col.type === 'date') && newObj.hasOwnProperty(col.name)) {
        if (col.name === 'dob') {
          newObj[col.name] = moment(newObj[col.name]).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        } else {
          newObj[col.name] = moment.utc(newObj[col.name]).local().format('YYYY-MM-DDTHH:mm:ss');
        }
        const date = moment(newObj[col.name]);
        if (!date.isValid()) {
          newObj[col.name] = '';
        }
      } else if (col.type === 'tags') {
        if (!newObj.hasOwnProperty(col.name)) {
          newObj[col.name] = [];
        } else {
          if (typeof newObj[col.name] === 'string') {
            newObj[col.name] = [];
          }
        }
      } else if (col.type === 'boolean' && col.name === 'isPasswordRequired' && newObj['isSuperAdmin']) {
        newObj[col.name] = true;
      } else if (this.data.dataType === 'session' && col.type === 'boolean' && newObj['isKeepActive'] && (col.name === 'autoend' || col.name === 'autostart')) {
        newObj[col.name] = false;
      }
      if (newObj[col.name] === null || newObj[col.name] === undefined) {
        if (col.type === 'reference') {
          if (col.name === 'role' || col.name === 'openbyroles') {
            newObj[col.name] = [{ _id: '', name: '' }];
          }
        } else if (col.type === 'boolean') {
          newObj[col.name] = false;
        } else if (col.type === 'color') {
          newObj[col.name] = '#ffffff';
        } else if (col.type === 'picturearray') {
          newObj[col.name] = [];
        } else if (col.type === 'maparray' || col.type === 'tags' || (col.type === 'enum' && col.multiple)) {
          newObj[col.name] = [];
        } else if (col.type === 'json') {
          newObj[col.name] = {};
        } else if (col.type === 'datetime') {
          newObj[col.name] = moment.utc().local().format('YYYY-MM-DDTHH:mm:ss');
        } else {
          newObj[col.name] = '';
        }
      } else if (col.type === 'number' && (newObj[col.name] === null || newObj[col.name] === '')) {
        newObj[col.name] = undefined;
      }
      if (col.type === 'picturearray') {
        newObj[col.name] = newObj[col.name].map((itm) => {
          itm['thumbnail'] = getOtherImage('', itm.url, '_thumbnail');
          return itm;
        });
      }
    }
    return newObj;
  }

  public getDateAtStamp(dt): string {
    let tempDate = new Date(dt);
    let datePipe = new DatePipe('en-US');
    let setDob = datePipe.transform(tempDate, 'yyyy-MM-ddTHH:mm:ss.SSS[Z]');
    return setDob;
  }
  public setBooleanAttribute(name, val) {
    if (val && name === 'isKeepActive') {
      this.data.data['autoend'] = false;
      this.data.data['autostart'] = false;
    }
    if (this.data.dataType === 'event') {
      if (name === 'isRecurrence') {
        if (val) {
          this.data.data['recurrence'] = JSON.parse(JSON.stringify(this.defaultRuleData));
          this.data.data['recurrence']['startdate'] = this.data.data.startdate;
          this.data.data['recurrence']['tzid'] = this.getUserTimeZone();
          this.setRuleText();
        }
        this.cleanFieldsMeta();
      }
    }
  }
  public setSuperAdminAttribute(val) {
    if (val) {
      this.data.data['isPasswordRequired'] = true;
    }
  }
  public setAdminAttribute(val) {
    this.data.data['isAdmin'] = val;
  }
  cleanFieldsMeta() {
    // let newFields = JSON.parse(JSON.stringify(this.data.modalSetting.fields));
    if (this.data.dataType === 'camera') {
      this.applySiteMappingCameraTypeEnum();
    }
    if (['user', 'case', 'camera', 'cameragroup', 'investigatorgroup', 'cameragroup'].includes(this.data.dataType)) {
      for (let col of this.data.modalSetting.fields) {
        if (col.name === 'prefecture') {
          col.enum.map((itm) => {
            if (itm.hasOwnProperty('region') && (itm.region === '' || itm.region === this.data.data['region'])) {
              itm['hide'] = false;
            } else {
              itm['hide'] = true;
            }
          });
        }
        if (['cameragroup'].includes(this.data.dataType)) {
          if (col.name === 'cameras') {
            if (!this.data.data[col.name]) {
              this.data.data[col.name] = [];
            }
            if (this.data.data['prefecture'] !== '') {
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "region", this.data.data['region']);
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "prefecture", this.data.data['prefecture']);
              col['disabled'] = false;
            } else {
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "region");
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "prefecture");
              col['disabled'] = true;
            }
            this.applySiteMappingCameraTypeFilter(col);
          }
        }
        if (['case', 'investigatorgroup'].includes(this.data.dataType)) {
          if (col.name === 'investigators') {
            if (!this.data.data[col.name]) {
              this.data.data[col.name] = [];
            }
            if (this.data.data['prefecture'] !== '') {
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "region", this.data.data['region']);
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "prefecture", this.data.data['prefecture']);
              col['disabled'] = false;
            } else {
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "region");
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "prefecture");
              col['disabled'] = true;
            }
          }
        }
        if (this.data.dataType === 'investigatorgroup') {
          if (col.name === 'picture_color') {
            // this.data.data[col.name] = '';
            if (this.data.data['display'] === 'coloredcircle') {
              col['visible'] = true;
              col['nullable'] = false;
            } else {
              col['visible'] = false;
              col['nullable'] = true;
            }
          }
          if (col.name === 'picture_text_color') {
            // this.data.data[col.name] = '';
            if (this.data.data['display'] === 'coloredcircle') {
              col['visible'] = true;
              col['nullable'] = false;
            } else {
              col['visible'] = false;
              col['nullable'] = true;
            }
          }
          if (col.name === 'picture_text') {
            // this.data.data[col.name] = '';
            if (this.data.data['display'] === 'coloredcircle') {
              col['visible'] = true;
              col['nullable'] = false;
            } else {
              col['visible'] = false;
              col['nullable'] = true;
            }
          }
          if (col.name === 'picture_size') {
            // this.data.data[col.name] = '';
            if (this.data.data['display'] === 'coloredcircle') {
              col['visible'] = true;
              col['nullable'] = false;
            } else {
              col['visible'] = false;
              col['nullable'] = true;
            }
          }
          if (col.name === 'picture_id') {
            // this.data.data[col.name] = '';
            if (this.data.data['display'] === 'icon') {
              col['visible'] = true;
            } else {
              col['visible'] = false;
            }
          }
        } else if (this.data.dataType === 'case') {
          if (col.name === 'investigatorgroup') {
            if (!this.data.data[col.name]) {
              this.data.data[col.name] = [];
            }
            if (this.data.data['prefecture'] !== '') {
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "region", this.data.data['region']);
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "prefecture", this.data.data['prefecture']);
              col['disabled'] = false;
              if (this.caseTypeSelect) {
                this.caseTypeSelect.filters = col['filters'];
                this.caseTypeSelect.refresh();
              }
            } else {
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "region");
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "prefecture");
              col['disabled'] = true;
            }
          } else if (col.name === 'case_id') {
            if (this.data.data.hasOwnProperty('_id')) {
              col['disabled'] = true;
            }
          } else if (col.name === 'casetype') {
            col['filters'] = { '$and': [{ 'organizationId._id': { '$eq': this.requestService.orgId } }] };
            if (this.data.data['prefecture'] !== '') {
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "region", this.data.data['region']);
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "prefecture", this.data.data['prefecture']);
              col['disabled'] = false;
            } else {
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "region");
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "prefecture");
              col['disabled'] = true;
            }
          }
        } else if (this.data.dataType === 'user') {
          if (col.name === 'email') {
            if (this.data.data.hasOwnProperty('_id')) {
              if (this.data.data['is_original_email']) {
                col.visible = true;
              } else {
                col.visible = false;
              }
            } else { // case create
              //do nothing
            }
          }
          if (col.name === 'division') {
            col['filters'] = {
              '$and': [
                { 'organizationId._id': { '$eq': this.requestService.orgId } }
              ]
            };
            if (this.data.data['prefecture'] !== '') {
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "region", this.data.data['region']);
              col['filters']['$and'] = this.updateFilterArray(col['filters']['$and'], "prefecture", this.data.data['prefecture']);
              col['disabled'] = false;
            } else {
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "region");
              col['filters']['$and'] = this.clearFilterArray(col['filters']['$and'], "prefecture");
              col['disabled'] = true;
            }
            // for (let customTag of this.customTags) {
            //   if (customTag.itemName === 'division') {
            //     customTag.refresh();
            //   }
            // }
          }
        } else if (this.data.dataType === 'camera') {
          if (col.name === 'stream_type') {
            if (!this.data.data['stream_type'] || this.data.data['stream_type'] === '') {
              this.data.data['stream_type'] = 'url';
            }

            if (['tablet-cam', 'police-cams'].includes(this.data.data['camera_type'])) {
              this.data.data['stream_type'] = 'live_stream';
              col.disabled = true;
            } else {
              col.disabled = false;
            }
          }
          // if (col.name === 'stream_url') {
          //   col.disabled = true;
          //   if (this.data.data['stream_type'] === 'rtmp/rtsp') {
          //     col.visible = true;
          //   } else {
          //     col.visible = false;
          //   }
          // }
          if (col.name === 'target_url') {
            if (this.data.data['stream_type'] != 'rtmp/rtsp' && this.data.data['stream_type'] != 'live_stream') {
              col.visible = true;
              col.nullable = false;
            } else {
              col.visible = false;
              col.nullable = true;
            }
          }
          if (col.name === 'rotation_start_at' || col.name === 'rotation_end_at' || col.name === 'shape_length') {
            if ((this.data.data['rotation_start_at'] == '' || this.data.data['rotation_start_at'] == undefined) && (this.data.data['rotation_end_at'] == '' || this.data.data['rotation_end_at'] == undefined) && (this.data.data['shape_length'] == '' || this.data.data['shape_length'] == undefined)) {
              col.nullable = true;
            } else {
              col.nullable = false;
            }
          }
          if (col.name == 'geolocation' || col.name == 'address' || col.name == 'address_jp' || col.name == 'shape_length' || col.name == 'camera_field_view_color' || col.name == 'rotation_start_at' || col.name == 'rotation_end_at') {
            if (this.data.data['camera_type'] == 'surveillance-cams') {
              if (col.name == 'address_jp' || col.name == 'address') {
                if ((col.name == 'address_jp' && this.selectedLocaleLang == 'ja') || (col.name == 'address' && this.selectedLocaleLang == 'en')) {
                  col.visible = true;
                } else {
                  col.visible = false;
                }
              } else {
                col.visible = true;
              }
            } else {
              col.visible = false;
            }
          }
          if (col.name == 'geolocation') {
            if (this.data.data['camera_type'] == 'surveillance-cams') {
              col.nullable = false;
            } else {
              col.nullable = true;
            }
          }
        }
      }
    }
    this.handleSubmitCustomError();
    // this.data.modalSetting.fields = JSON.parse(JSON.stringify(newFields));
  }
  openGallery(id, col) {
    let region = undefined;
    let prefecture = undefined;
    if (!this.isSuperAdmin && this.selectedUser.region && this.selectedUser.region !== '') {
      region = this.selectedUser.region;
    }
    if (!this.isSuperAdmin && this.selectedUser.prefecture && this.selectedUser.prefecture !== '') {
      prefecture = this.selectedUser.prefecture;
    }
    const dialogRef = this.dialog.open(ModalGalleryDialogComponent, {
      autoFocus: false,
      width: '1200px',
      disableClose: false,
      data: {
        title: this.translate.instant('Image Gallery'),
        galleryType: col.gallery.type,
        region: region,
        prefecture: prefecture,
        selectedImage: this.data.data[col.gallery.target],
        parentClear: true

      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('ModalGalleryDialogComponent', result);
        if (result.action) {
          if (result.action === 'clear') {
            this.data.data[col.gallery.target] = '';
            this.data.data[id] = '';
          } else if (result.action === 'select') {
            this.data.data[col.gallery.target] = result.image[col.gallery.source];
            this.data.data[id] = { _id: result.image._id, name: '' };
          }
        }
      }
    });
  }
  private applySiteMappingCameraTypeFilter(col: any): void {
    if (!col) {
      return;
    }
    if (!col.filters) {
      col.filters = { $and: [] };
    }
    if (!Array.isArray(col.filters.$and)) {
      col.filters.$and = [];
    }
    if (!this.enableSiteMapping) {
      col.filters.$and = this.updateFilterArray(col.filters.$and, 'camera_type', SITE_MAPPING_CAMERA_TYPES, '$nin');
    } else {
      col.filters.$and = this.clearFilterArray(col.filters.$and, 'camera_type');
    }
  }
  updateFilterArray(currentArray: any[], id, value, action = '$eq'): any[] {
    let isFound = false;
    for (let itm of currentArray) {
      if (itm.hasOwnProperty(id)) {
        itm[id] = {};
        itm[id][action] = value;
        isFound = true;
      }
    }
    if (!isFound) {
      let itm = {};
      itm[id] = {};
      itm[id][action] = value;
      currentArray.push(itm);
    }
    return currentArray;
  }
  clearFilterArray(currentArray: any[], id: string): any[] {
    currentArray = currentArray.map((itm) => {
      if (itm.hasOwnProperty(id)) {
        itm['delete'] = true;
      }
      return itm;
    });
    currentArray = currentArray.filter(itm => !itm.delete);
    return currentArray;
  }
  updateFieldsMeta(id, targetId, targetValue) {
    let newFields = JSON.parse(JSON.stringify(this.data.modalSetting.fields));
    for (let col of newFields) {
      if (col.name === id) {
        col[targetId] = targetValue;
      }
    }
    this.data.modalSetting.fields = JSON.parse(JSON.stringify(newFields));
  }
  clearSimpleValue(e, id, val = undefined): any {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setAttribute(id, val);
  }
  public setRotationLengthAttribute(id, val) {
    this.data.data[id] = val;
    this.cleanFieldsMeta();
  }
  public setAttribute(id, val) {
    this.data.data[id] = val;
    if (this.data.dataType === 'event') {
      if (id === 'category') {
        this.data.data['subcategory'] = '';
        this.data.data['others'] = '';
      }
      if (id === 'subcategory') {
        this.data.data['others'] = '';
        this.data.data['facility'] = '';
      }
      this.cleanFieldsMeta();
    } else if (['user', 'case', 'camera', 'cameragroup', 'investigatorgroup', 'cameragroup'].includes(this.data.dataType)) {
      if (id === 'region') {
        this.data.data['prefecture'] = '';
      }
      if (['cameragroup'].includes(this.data.dataType)) {
        if (id === 'region' || id === 'prefecture') {
          this.data.data['cameras'] = [];
        }
      }
      if (this.data.dataType === 'user') {
        if (id === 'region' || id === 'prefecture') {
          for (let customTag of this.customTags) {
            if (customTag.itemName === 'division') {
              customTag.region = this.data.data['region'];
              customTag.prefecture = this.data.data['prefecture'];
              customTag.clearIt(undefined);
            }
          }
          this.data.data['division'] = [];
        }
      }
      if (['case', 'investigatorgroup'].includes(this.data.dataType)) {
        if (id === 'region' || id === 'prefecture') {
          this.data.data['investigators'] = [];
        }
        if (id === 'display') {
          this.data.data['picture_id'] = '';
          this.data.data['picture_text'] = '';
          this.data.data['picture_size'] = '';
          this.data.data['picture'] = '';
          if (val === 'coloredcircle') {
            this.data.data['picture_color'] = '#000000';
            this.data.data['picture_text_color'] = '#000000';
          } else {
            this.data.data['picture_color'] = '';
            this.data.data['picture_text_color'] = '';
          }
        }
      }
      if (this.data.dataType === 'case') {
        if (id === 'region' || id === 'prefecture') {
          this.caseTypeSelect.region = this.data.data['region'];
          this.caseTypeSelect.prefecture = this.data.data['prefecture'];
          this.caseTypeSelect.clearIt(undefined);
          this.data.data['investigatorgroup'] = [];
        }
      }
      if (this.data.dataType === 'camera') {
        if (id === 'stream_type') {
          this.data.data['stream_url'] = '';
          this.data.data['target_url'] = '';
        }
        if (id === 'camera_type') {
          if (val == 'police-cams' || val == 'building-cams') {
            this.clearLocation();
          }
        }
      }
      this.cleanFieldsMeta();
    }

  }
  public setAttributeBoolean(id, val) {
    this.data.data[id] = JSON.parse(val);
  }
  public manageCaseType(datatype) {
    // Only allow managing case types when region and prefecture are selected
    const region = this.data?.data?.['region'];
    const prefecture = this.data?.data?.['prefecture'];

    if (!region || !prefecture) {
      this.layoutUtilsService.showNotification(
        this.translate.instant('Please select both Region and Prefecture first'),
        this.translate.instant('Dismiss')
      );
      return;
    }

    const dialogRef = this.dialog.open(CustomCreateTableDialogComponent, {
      autoFocus: false,
      width: '800px',
      data: {
        title: this.translate.instant('Manage'),
        dataType: datatype,
        dataTypeDisplay: 'Case Type',
        dataTypeSingleDisplay: 'Case Type',
        focusField: 'name',
        defaultFields: ['name', 'color'],
        fieldsToHide: [],
        canNew: true,
        region: region,
        prefecture: prefecture
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // if (result) {
      this.changeOccured = true;
      this.caseTypeSelect.refresh();
      // console.log(result);
      // do something
      // }
    });
  }
  public setReferenceAttribute(parentId, id, val) {
    // console.log('setReferenceAttribute', parentId, id, val);
    if (val.hasOwnProperty('_id')) {
      this.data.data[parentId][id] = val._id;
      if (val.hasOwnProperty('name')) {
        this.data.data[parentId]['name'] = val.name;
      }
      if (val.hasOwnProperty('text')) {
        this.data.data[parentId]['name'] = val.text;
      }
    } else {
      if (!this.data.data[parentId]) {
        this.data.data[parentId] = {};
      }
      this.data.data[parentId][id] = val;
    }
  }
  public setReferenceControllerAttribute(parentId, id, val) {
    // console.log('setReferenceControllerAttribute', parentId, id, val);
    this.data.data[parentId] = val;
    this.loadControllerData(val._id, parentId);

  }
  public setMultipleReferenceAttribute(id, val) {
    this.data.data[id] = val;
  }
  public setRoleReferenceAttribute(parentId, val) {
    // if (val !== this.adminId) {
    //   this.data.data['isSuperAdmin'] = false;
    // }
    this.data.data[parentId] = [{ _id: val._id, name: val.name }];
    if (parentId === 'resources' && this.data.dataType === 'user') {
      this.data.data['isAdmin'] = false;
    }
    if (parentId === 'resources' && this.data.dataType === 'user') {
      this.cleanFieldsMeta();
    }
  }
  public setRoleAttribute(parentId, val) {
    this.data.data[parentId] = [{ _id: val._id, name: val.name }];
  }
  public setDateTimeAttribute(id, val) {
    // let dtstart = moment(val).utc().toDate();
    if (val) {
      this.data.data[id] = moment(val).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    } else {
      this.data.data[id] = '';
    }
    if ((id === 'startdate' || id === 'enddate') && this.data.dataType === 'event') {
      this.cleanFieldsMeta();
    }
  }
  public setStartEndDateTimeAttribute(data) {
    // console.log(data);
    for (let val of data) {
      if (val.id === 'startdate') {
        this.data.data['startdate'] = moment(val.value).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      } else if (val.id === 'enddate') {
        this.data.data['enddate'] = moment(val.value).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      } else if (val.id === 'allday') {
        this.data.data['allday'] = JSON.parse(val.value);
      }
    }
    this.cleanFieldsMeta();
    // console.log(this.data.data);
  }
  public calculateAge(birthdate) {
    if (birthdate) {
      var timeDiff = Math.abs(Date.now() - birthdate);
      //Used Math.floor instead of Math.ceil
      //so 26 years and 140 days would be considered as 26, not 27.
      this.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
  }
  public calculateYearInService(yearInService) {
    if (yearInService) {
      let date2 = new Date();
      const year1 = yearInService.getFullYear();
      const year2 = date2.getFullYear();

      this.yearsInService = Math.abs(year1 - year2);
    } else {
      this.yearsInService = '';
    }
  }
  public calculateYearInServiceOld(yearInService) {
    if (yearInService) {
      var timeDiff = Math.abs(Date.now() - yearInService);
      //Used Math.floor instead of Math.ceil
      //so 26 years and 140 days would be considered as 26, not 27.
      // this.yearsInService = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
      let yearsInService = (timeDiff / (1000 * 3600 * 24)) / 365;
      this.yearsInService = Math.round(yearsInService * 10) / 10;
    } else {
      this.yearsInService = '';
    }
  }
  public setDateAttribute(id, val) {
    // console.log('setDateAttribute', id, val.toISOString());
    // Check if the variable is a moment object
    if (moment.isMoment(val)) {
      this.data.data[id] = val.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      if (id === 'year-started' && this.data.dataType === 'user') {
        this.calculateYearInService(val.toDate());
      }
    } else {
      try {
        this.data.data[id] = val.toISOString();
        // if (id === 'dob' && this.data.dataType === 'user') {
        //   this.calculateAge(val);
        // }
        if (id === 'year-started' && this.data.dataType === 'user') {
          this.calculateYearInService(val);
        }
      } catch (e) {
        // error
        //console.log('setDateAttribute', e);
        if (id === 'year-started' && this.data.dataType === 'user') {
          this.calculateYearInService(undefined);
        }
      }
    }
  }
  public setYearAttribute(id, val) {
    this.selectedYear[id] = val;
    if (val) {
      let date = new Date(val, 0, 29);
      this.data.data[id] = date;
    } else {
      this.data.data[id] = "";
    }

  }
  // public setYearServiceAttribute(id, val) {
  //   this.selectedYear[id] = val;
  //   if (val) {
  //     let date = new Date(val, 0, 29);
  //     this.data.data[id] = date;
  //     this.calculateYearInService(date);
  //   } else {
  //     this.data.data[id] = "";
  //     this.calculateYearInService(undefined);
  //   }

  // }
  public clearYearAttribute(e, id, val) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setYearAttribute(id, val)
  }
  // public clearYearServiceAttribute(e, id, val) {
  //   if (e) {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   }
  //   this.setYearServiceAttribute(id, val)
  // }
  public loadControllerData(dataId, controller) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.getSingleData(this.data.dataType, dataId, (data, error) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + error, this.translate.instant('Dismiss'));
        }
        if (data) {
          this.data.data = this.updateObject(this.data.data, controller, data.results);
        }
        this.loading = false;
      });
    }
  }
  private updateObject(data, controller, newData) {
    let newObj = data;
    for (let col of this.data.modalSetting.fields) {
      if (col.hasOwnProperty('controller') && col.controller === controller) {
        newObj[col.name] = newData[col.name];
      }
    }
    return newObj;
  }
  private getCleanObject(data) {
    let newObj: any = { _id: data._id };
    for (let col of this.data.modalSetting.fields) {
      if ((col.editable || !col.generated) && col.type !== 'action') {
        if (col.dataType === 'password') {
          newObj[col.name] = urlSafeBase64Encoding(data[col.name]);
        } else if (col.type === 'reference') {
          if (col.reference.kind === 'multiple') {
            if (data[col.name] && data[col.name].length > 0) {
              if (col.name === 'resources' || col.name === 'role') {
                data[col.name] = data[col.name].splice(0, 1);
                newObj[col.name] = data[col.name];
              } else {
                newObj[col.name] = data[col.name];
              }
            } else if (data[col.name] && data[col.name].length === 0) {
              newObj[col.name] = data[col.name];
            }
            if (col.name === 'openbyroles' && data[col.name] && data[col.name].length === 0) {
              newObj[col.name] = [];
            }
          } else {
            if (data[col.name] !== '')
              newObj[col.name] = data[col.name];
          }
        } else if (col.type === 'enum' && col.multiple && data.hasOwnProperty(col.name) && data[col.name].length === 0) {
          newObj[col.name] = [];
        } else if (col.type === 'datetime' || col.type === 'date') {
          if (col.name === 'dob') {
            if (data[col.name] !== '') {
              newObj[col.name] = moment(data[col.name]).format('YYYY-MM-DD') + 'T00:00:00';
            }
          } else {
            newObj[col.name] = moment(data[col.name]).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
          }
          const date = moment(newObj[col.name]);
          if (!date.isValid() || !newObj[col.name]) {
            newObj[col.name] = '';
          }
        } else if (col.type === 'objectjson') {
          if ((col.name === 'attendees') && this.data.dataType === 'event') {
            let attendeesOptionsSelected = [];
            if (data[col.name + 'Id'] && data[col.name + 'Id'].length > 0) {
              attendeesOptionsSelected = this.data.modalSetting.customSettings[col.name].options.filter((itm) => data[col.name + 'Id'].includes(itm._id));
            }
            newObj[col.name] = attendeesOptionsSelected;

          } else {
            newObj[col.name] = data[col.name];
          }
        } else if (col.type == 'number' && (col.name == 'rotation_start_at' || col.name == 'rotation_end_at' || col.name == 'shape_length')) {
          newObj[col.name] = Number(data[col.name]);
        } else {
          newObj[col.name] = data[col.name];
        }
        // if (this.data.modalSetting.hasOwnProperty('customSettings')) {
        //   if (this.data.modalSetting.customSettings.hasOwnProperty(col.name)) {
        //     newObj[col.name] = this.data.modalSetting.customSettings[col.name].value;
        //   }
        // }
      }
    }
    if (this.data.dataType === 'user') {
      if (newObj.hasOwnProperty('_id') && newObj._id) {
        // clean not needed in user to update data
        delete newObj['organizationId'];
        delete newObj['appId'];
        delete newObj['locationId'];
        delete newObj['sessions'];
        // if (newObj.isSuperAdmin) {
        //   delete newObj['resources'];
        // }
      } else {
        if (newObj.hasOwnProperty('listedInTheDirectory')) {
          // On create set isTextChat and isVideoChat to true if listedInTheDirectory is set yes
          if (newObj['listedInTheDirectory'] === 'yes') {
            newObj['isTextChat'] = true;
            newObj['isVideoChat'] = true;
          } else {
            newObj['isTextChat'] = false;
            newObj['isVideoChat'] = false;
          }
        }
        // sendEmail on create is sent for Send registration email
        newObj['sendEmail'] = this.sendEmail;
      }
      // } else if (this.data.dataType === 'case') {
      //   newObj['name'] = newObj['case_id'];
    } else if (this.data.dataType === 'camera') {
      newObj['name'] = newObj['camera_id'];
    }

    return newObj;
  }
  private validateObject(data: any) {
    for (let col of this.data.modalSetting.fields) {
      if ((!col.nullable && (!col.generated || (col.generated && col.editable && this.action == 'edit'))) && col.type !== 'action' && col.name !== 'privacyterm' && (col.visible || (col.admin && this.isAdmin) || (col.superadmin && this.isSuperAdmin))) {
        if (col.type === 'reference') {
          if (col.reference.kind === 'multiple') {
            // console.log('col.name', col.name, data[col.name] );
            if (col.name === 'resources' || col.name === 'role' || col.name === 'openbyroles') {
              if (data && data[col.name] && data[col.name].length === 0) {
                return false;
              }
              if (!data[col.name][0]['_id'] || data[col.name][0]['_id'] === '') {
                return false;
              }
            } else {
              if (data && data[col.name] && data[col.name].length === 0) {
                return false;
              }
            }
          } else {
            if (data && data[col.name] && (data[col.name]['_id'] === '' || !data[col.name]['_id'])) {
              // console.log('col.name', col.name, data[col.name] );
              return false;
            }
            if (col.name == 'casetype' && !this.caseTypeSelect._value) {
              return false;
            }
          }
        } else if (col.type === 'tags') {
          if (data && (data[col.name].length === 0 || data[col.name] === undefined)) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        } else if (col.type === 'picturearray') {
          if (data && (data[col.name].length === 0 || data[col.name] === undefined)) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        } else if (col.type === 'email') {
          if (data && (data[col.name].length === 0 || data[col.name] === undefined || !this.isEmailValid(data[col.name]))) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        } else if (col.type === 'url') {
          if (data && (data[col.name].length === 0 || data[col.name] === undefined)) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        } else if (col.type === 'password') {
          if (data && ((data[col.name] === '' || data[col.name] === undefined) || (data[col.name] && data[col.name].length < 8 && data[col.name].length > 64))) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        } else if (col.type === 'objectjson') {
          if ((col.name === 'attendees') && this.data.dataType === 'event') {
            if (data && data.hasOwnProperty(col.name + 'Id') && (data[col.name + 'Id'].length === 0 || data[col.name + 'Id'] === '')) {
              return false;
            }
          }
        } else if (col.type === 'datetime') {
          if (data && (data[col.name] === 'Invalid date' || data[col.name] === '' || data[col.name] === undefined)) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
          if (this.customDateTimeComponent) {
            let comList = this.customDateTimeComponent.toArray();
            const dateTimeByName: any = comList.find(c => c.name == col.name);
            if (dateTimeByName && (!dateTimeByName.timeValue || dateTimeByName.timeValue == "")) {
              return false;
            }
          }
        } else {
          if (data && (data[col.name] === '' || data[col.name] === undefined)) {
            // console.log('col.name', col.name, data[col.name] );
            return false;
          }
        }
      }
    }
    return true;
  }
  private validateSubscriptionLogic(type, data, orgSubscriptionData) {
    if (orgSubscriptionData.subscription_status === 'paid') {
      if (type === 'create') {
        if (data['type'] === '3' && orgSubscriptionData.number_of_remaining_exhibit_rooms <= 0) {
          this.layoutUtilsService.showNotification(this.translate.instant('You cannot add more exhibit rooms, contact your sales'), this.translate.instant('Dismiss'));
          return false;
        }
        // else if (data['type'] !== '3' && orgSubscriptionData.number_of_remaining_advanced_rooms <= 0) {
        //   this.layoutUtilsService.showNotification(this.translate.instant('You cannot add more rooms, contact your sales'), this.translate.instant('Dismiss'));
        //   return false;
        // }
      } else if (type === 'edit') {
        if (this.originalData['type'] !== data['type'] && data['type'] === '3' && orgSubscriptionData.number_of_remaining_exhibit_rooms <= 0) {
          this.layoutUtilsService.showNotification(this.translate.instant('You cannot add more exhibit rooms, contact your sales'), this.translate.instant('Dismiss'));
          return false;
        }
        // else if (this.originalData['type'] !== data['type'] && data['type'] !== '3' && orgSubscriptionData.number_of_remaining_advanced_rooms <= 0) {
        //   this.layoutUtilsService.showNotification(this.translate.instant('You cannot add more rooms, contact your sales'), this.translate.instant('Dismiss'));
        //   return false;
        // }
      }
    }
    return true;
  }
  private validateLogic(data) {
    for (let col of this.data.modalSetting.fields) {
      if (!col.generated && col.type !== 'action' && col.name !== 'privacyterm' && (col.visible || (col.admin && this.isAdmin) || (col.superadmin && this.isSuperAdmin))) {
        if (col.hasOwnProperty('charlimit') && col.charlimit > 0) {
          if (data && data[col.name] && data[col.name].length > col.charlimit) {
            return this.translate.instant(col.displayName) + ' ' + this.translate.instant('should have a maximum of') + ' ' + col.charlimit + ' ' + this.translate.instant('characters');
          }
        } else {
          if (col.type === 'textarea') {
            if (data && data[col.name] && data[col.name].length > 1000) {
              return this.translate.instant(col.displayName) + ' ' + this.translate.instant('should have a maximum of 1000 characters');
            }
          }
        }
        if (col.type === 'lnglat' && !col.nullable) {
          if (data && data[col.name] !== undefined && data[col.name].length === 0) {
            return this.translate.instant(col.displayName) + ' ' + this.translate.instant('should be selected on the map');
          }
        }
        if (col.integer) {
          if (data && data[col.name] && data.hasOwnProperty(col.name) && data[col.name] !== '' && !Number.isInteger(data[col.name])) {
            return this.translate.instant(col.displayName) + ' ' + this.translate.instant('should be an integer');
          }
        }
        if (col.positive) {
          let currentValue = Number(data[col.name]);
          if (data && data.hasOwnProperty(col.name) && Number.isInteger(currentValue) && currentValue < 0) {
            return this.translate.instant('Fill in a valid number.');
          }
        }
        if (col.max !== undefined) {
          let currentValue = Number(data[col.name]);
          if (data && data.hasOwnProperty(col.name) && Number.isInteger(currentValue) && currentValue > col.max) {
            return this.translate.instant('Fill in a valid number.');
          }
        }
        if (col.min !== undefined) {
          let currentValue = Number(data[col.name]);
          if (data && data.hasOwnProperty(col.name) && Number.isInteger(currentValue) && currentValue < col.min) {
            return this.translate.instant('Fill in a valid number.');
          }
        }
        if (col.type === 'picturearray') {
          if (data && data[col.name] && data[col.name].length > 0) {
            let idx = 0;
            for (let pc of data[col.name]) {
              idx = idx + 1;
              if (!pc.link || pc.link === '') {
                if (pc.type === 'link') {
                  return this.translate.instant('Fill in the URL link for picture' + idx);
                } else if (pc.type === 'none') {
                  // do nothing
                } else {
                  return this.translate.instant('Select the correct ' + pc['type'] + ' to open');
                }
              }
              if (pc.type === 'link') {
                if (!isValidHttpUrl(pc.link) || !isValidCustomUrl(pc.link)) {
                  return this.translate.instant('Fill in the correct URL link format');
                }
              }
            }
          }
        } else if (col.type === 'url') {
          if (data && data[col.name] && data[col.name].length > 0) {
            if (!isValidHttpUrl(data[col.name]) || !isValidCustomUrl(data[col.name])) {
              return this.translate.instant('Fill in the correct URL link format');
            }
          }
        }
      }
      if (((!col.nullable || (col.nullable && col.type === 'boolean') || (col.nullable && col.type === 'number' && data[col.name] !== undefined && data[col.name] !== null && data[col.name] !== "")) && !col.generated) && col.type !== 'action' && col.name !== 'privacyterm' && ((col.visible || (!col.visible && this.data.dataType == 'event' && col.name == 'startdate')) || (col.admin && this.isAdmin) || (col.superadmin && this.isSuperAdmin))) {
        if (col.hasOwnProperty('validation')) {
          for (let vald of col.validation) {
            if (vald.operator === 'lt') {
              if (col.type === 'datetime') {
                // console.log('data[vald.target]', data[vald.target]);
                // console.log('moment(data[col.name]', data[col.name]);
                // console.log('minutes', moment(data[vald.target]).diff(moment(data[col.name]), 'minutes'));
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] && data[vald.target] && moment(data[vald.target]).diff(moment(data[col.name]), 'minutes') > 0)) {
                    return col.displayName + ' should be less than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                }
              } else {
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] !== undefined && data[vald.target] !== undefined && data[col.name] < data[vald.target])) {
                    return col.displayName + ' should be less than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                } else if (vald.hasOwnProperty('value')) {
                  if (!(data[col.name] !== undefined && data[col.name] < vald.value)) {
                    return col.displayName + ' should be greater than ' + vald.value;
                  }
                }
              }
            } else if (vald.operator === 'gt') {
              if (col.type === 'datetime') {
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] && data[vald.target] && moment(data[col.name]).diff(moment(data[vald.target]), 'minutes') > 0)) {
                    return col.displayName + ' should be greater than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                } else {
                  if (!(data[col.name] && moment(data[col.name]).diff(moment(), 'minutes') > 0)) {
                    return col.displayName + ' should be greater than current date';
                  }
                }
              } else {
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] !== undefined && data[vald.target] !== undefined && data[col.name] > data[vald.target])) {
                    return col.displayName + ' should be greater than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                } else if (vald.hasOwnProperty('value')) {
                  if (!(data[col.name] !== undefined && data[col.name] > vald.value)) {
                    return col.displayName + ' should be greater than ' + vald.value;
                  }
                }
              }
            } else if (vald.operator === 'gte') {
              if (col.type === 'datetime') {
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] && data[vald.target] && moment(data[col.name]).diff(moment(data[vald.target]), 'minutes') >= 0)) {
                    return col.displayName + ' should be greater or equal than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                } else {
                  if (!(data[col.name] && moment(data[col.name]).diff(moment(), 'minutes') >= 0)) {
                    return col.displayName + ' should be greater or equal than current date';
                  }
                }
              } else {
                if (vald.hasOwnProperty('target')) {
                  if (!(data[col.name] !== undefined && data[vald.target] !== undefined && data[col.name] >= data[vald.target])) {
                    return col.displayName + ' should be greater or equal than ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                } else if (vald.hasOwnProperty('value')) {
                  if (!(data[col.name] !== undefined && data[col.name] >= vald.value)) {
                    return col.displayName + ' should be greater or equal than ' + vald.value;
                  }
                }
              }
            } else if (vald.operator === 'eq') {
              if (vald.hasOwnProperty('target')) {
                if (data[col.name] !== data[vald.target]) {
                  if (vald.hasOwnProperty('value')) {
                    if (data[col.name] !== vald.value) {
                      return col.displayName + ' should be equal to ' + this.metaFieldSetting[vald.target]['displayName'];
                    }
                  } else {
                    return col.displayName + ' should be equal to ' + this.metaFieldSetting[vald.target]['displayName'];
                  }
                }
              } else if (vald.hasOwnProperty('value')) {
                if (data[col.name] !== vald.value) {
                  return col.displayName + ' should be equal to ' + vald.value;
                }
              }
            } else if (vald.operator === 'url') {
              if (!this.isUrlValid(data[col.name])) {
                return col.displayName + ' should be in URL format.';
              }
            }
          }
        }
      }
    }
    return undefined;
  }
  checkTagsSaving() {
    let status = false;
    this.customTags.forEach((child) => { if (child.loading) { status = true } })
    return status;
  }
  getOrgData(callback) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.getSingleData('organization', this.requestService.orgId, (data, error) => {
        if (error) {
          this.errorMessage = error;
          callback(this.organization);
        }
        this.loading = false;
        if (data && data.results) {
          let orgData = data.results;
          localStorage.setItem('org', JSON.stringify(orgData));
          this.requestService.pageOrganization.next(orgData);
          callback(orgData);
        }
      });
    }
  }
  getDataByName(datatype, name, callback) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      let filters = {
        "foreign_key": { "$eq": this.requestService.orgId },
        'project': { '$eq': 'stellar-' + this.vertical },
        'eventType': { '$eq': 'blueprint' },
        'name': { '$eq': name },
      };
      this.requestService.getDataListSummary(datatype, { page: 1, term: '', perpage: 1, filter: filters, orderBy: 'name', orderDir: 'asc', fieldKeys: ['name'] }, (data, error) => {
        this.loading = false;
        if (error) {
          this.errorMessage = error;
        }
        if (data && data.results) {
          if (data.results.length > 0) {
            callback(true);
            return;
          }
        }
        callback(false);
      });
    }
  }
  getUserInfoByEmail(email, callback) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.getUserInfoByEmail(email, (data, error) => {
        if (error) {
          this.errorMessage = error;
          callback(undefined);
        }
        this.loading = false;
        if (data) {
          callback(data);
        }
      });
    }
  }
  public handleSubmitCustomError() {
    let status = false;
    if (this.data.dataType === 'case') {
      if (this.data && this.data.data) {
        if (this.data.data.hasOwnProperty('region') && this.data.data.hasOwnProperty('prefecture') && (this.data.data['region'] === "" || this.data.data['prefecture'] === "")) {
          this.customError['investigators'] = { show: true, message: 'Please select a Region and a Prefecture.' };
          this.customError['investigatorgroup'] = { show: true, message: 'Please select a Region and a Prefecture.' };
          this.customError['casetype'] = { show: true, message: 'Please select a Region and a Prefecture.' };
        } else {
          this.customError['investigators'] = undefined;
          this.customError['investigatorgroup'] = undefined;
        }
      }
    }
    if (this.data.dataType === 'investigatorgroup') {
      if (this.data && this.data.data) {
        if (this.data.data.hasOwnProperty('region') && this.data.data.hasOwnProperty('prefecture') && (this.data.data['region'] === "" || this.data.data['prefecture'] === "")) {
          this.customError['investigators'] = { show: true, message: 'Please select a Region and a Prefecture.', showError: true };
        } else {
          this.customError['investigators'] = undefined;
        }
      }
    }
    if (this.data.dataType === 'cameragroup') {
      if (this.data && this.data.data) {
        if (this.data.data.hasOwnProperty('region') && this.data.data.hasOwnProperty('prefecture') && (this.data.data['region'] === "" || this.data.data['prefecture'] === "")) {
          this.customError['cameras'] = { show: true, message: 'Please select a Region and a Prefecture.', showError: true };
        } else {
          this.customError['cameras'] = undefined;
        }
      }
    }
    return status;
  }
  public deleteData(checkusability: boolean = false) {
    if (this.loading || !this.data || !this.data.data || !this.data.data['_id']) {
      return;
    }
    const _title: string = this.translate.instant(this.data.dataTypeSingleTitle) + ' ' + this.translate.instant('Deletion');
    const _description: string = this.translate.instant('Are you sure you want to permanently delete this') + ' ' + this.translate.instant(this.data.dataTypeSingleTitle) + '?';
    const _waitDesciption: string = this.translate.instant('Deleting') + '...';

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.loading = true;
      this.errorMessage = '';
      const id = this.data.data['_id'];
      this.requestService.deleteSingleData(this.data.dataType, id, (data, error) => {
        this.loading = false;
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(this.translate.instant(error), this.translate.instant('Dismiss'));
        }
        if (data) {
          const _deleteMessage = this.translate.instant(this.data.dataTypeSingleTitle) + ' ' + this.translate.instant('deleted successfully');
          this.layoutUtilsService.showNotification(_deleteMessage, this.translate.instant('Dismiss'));
          this.returnRefresh();
          if (this.data.dataType === 'case') {
            if (!this.router.url.startsWith('/cases/list')) {
              this.router.navigate(['/cases/list']);
            }
          }
        }
      }, undefined, checkusability);
    });
  }
  public saveData(type) {
    // console.log(this.personForm['form']);
    this.isSubmitted = true;
    if (this.handleSubmitCustomError()) {
      return;
    }
    if (this.data.dataType === 'room') {
      // fetch data of room
      this.getOrgData((orgData) => {
        let orgSubscriptionData = orgData.subscriptions;
        if (orgSubscriptionData) {
          let validateSubscriptionLogic = this.validateSubscriptionLogic(type, this.data.data, orgSubscriptionData);
          if (validateSubscriptionLogic) {
            this.saveContinueData(type);
          }
        } else {
          this.saveContinueData(type);
        }
      });
    } else if (this.data.dataType === 'session' && type === 'edit') {
      if (this.data.data['streamMode'] === 'meeting' && (this.data.data['attendance'] === 'in-person' || this.data.data['attendance'] === 'hybrid')) {
        this.layoutUtilsService.showNotification('This session has Meeting mode. The attendance can only be set to Online. Please switch to Online attendance or change the Streaming Mode.', this.translate.instant('Dismiss'));
      } else {
        this.saveContinueData(type);
      }
    } else if (this.data.dataType === 'event') {
      if (type === 'edit') {
        // if (this.data.data.isRecurrence) { // added this to make sure the recurence startdate is same as the event one
        //   this.data.data['recurrence']['startdate'] = this.data.data['startdate'];
        // }
        if (this.originalData && (this.originalData['startdate'] && moment(this.originalData['startdate']).diff(moment(), 'minutes') < 0) && (this.originalData['enddate'] && moment(this.originalData['enddate']).diff(moment(), 'minutes') > 0)) {
          const _title: string = 'Alert';
          const _description: string = this.translate.instant('This event has already started. Are you sure you want to continue?');
          let alertSetting = {
            overlayClickToClose: false,
            showCloseButton: false,
            confirmText: this.translate.instant('Confirm'),
            declineText: this.translate.instant('Close'),
          };
          const dialogRef = this.layoutUtilsService.alertActionElement(_title, _description, alertSetting);
          dialogRef.afterClosed().subscribe(res => {
            if (res.action === 'confirmText') {
              this.saveContinueData(type);
            }
          });
        } else if (this.originalData && this.originalData['isRecurrence'] && this.data.data['isRecurrence'] && ((this.originalData['startdate'] !== this.data.data['startdate']) || !deepEqual(this.originalData['recurrence'], this.data.data['recurrence']))) {
          const _title: string = 'Alert';
          const _description: string = this.translate.instant('This event is recurrent and the update will be applied to all the events in this series');
          let alertSetting = {
            overlayClickToClose: false,
            showCloseButton: false,
            confirmText: this.translate.instant('OK'),
            declineText: this.translate.instant('Cancel'),
          };
          const dialogRef = this.layoutUtilsService.alertActionElement(_title, _description, alertSetting);
          dialogRef.afterClosed().subscribe(res => {
            if (res.action === 'confirmText') {
              this.saveContinueData(type);
            }
          });
        } else {
          this.saveContinueData(type);
        }
      } else {
        if (this.data.data['eventType'] && this.data.data['eventType'] === 'blueprint') {
          if ((this.originalData && this.originalData['name'] && this.originalData['name'] !== this.data.data['name'])) {
            this.getDataByName('event', this.data.data['name'], (callback) => {
              if (callback) {
                this.layoutUtilsService.showNotification(this.translate.instant('Blueprint name is already in use.'), this.translate.instant('Dismiss'));
              } else {
                this.saveContinueData(type);
              }
            });
          } else {
            this.saveContinueData(type);
          }
          // } else if (this.data.data['eventType'] && this.data.data['eventType'] === 'occurrence') {
          //   if (this.isAdmin && (this.data.data && (this.data.data['startdate'] && moment(this.data.data['startdate']).diff(moment(), 'minutes') < 0))) {
          //     const _title: string = 'Alert';
          //     const _description: string = this.translate.instant('The Start Date of this event has already passed. Are you sure you want to create a new event?');
          //     let alertSetting = {
          //       overlayClickToClose: false,
          //       showCloseButton: false,
          //       confirmText: this.translate.instant('Confirm'),
          //       declineText: this.translate.instant('Close'),
          //     };
          //     const dialogRef = this.layoutUtilsService.alertActionElement(_title, _description, alertSetting);
          //     dialogRef.afterClosed().subscribe(res => {
          //       if (res.action === 'confirmText') {
          //         this.saveContinueData(type);
          //       }
          //     });
          //   } else {
          //     this.saveContinueData(type);
          //   }
        } else {
          this.saveContinueData(type);
        }
      }
      // } else if (this.data.dataType === 'user' && this.data.data['email'] && this.data.data['email'].trim() !== '' && !this.data.data['isSuperAdmin'] && this.isSuperAdmin && this.data.data['resources']) {
      //   let rolesList = this.requestService.getUserRoleByUserDataNoOrg(this.data.data);
      //   if (rolesList === 'admin') {
      //     this.getUserInfoByEmail(this.data.data['email'], (userData) => {
      //       let isSuperAdmin = userData?.isSuperAdmin;
      //       if (isSuperAdmin) {
      //         const _title: string = 'Alert';
      //         const _description: string = this.translate.instant('The user you are trying to create or update is an existing Super Admin. Are you sure you want to remove their Super Admin rights? Note that this will have a global effect.');
      //         let alertSetting = {
      //           overlayClickToClose: false,
      //           showCloseButton: false,
      //           confirmText: this.translate.instant('Confirm'),
      //           declineText: this.translate.instant('Close'),
      //         };
      //         const dialogRef = this.layoutUtilsService.alertActionElement(_title, _description, alertSetting);
      //         dialogRef.afterClosed().subscribe(res => {
      //           if (res.action === 'confirmText') {
      //             this.saveContinueData(type);
      //           }
      //         });
      //       } else {
      //         this.saveContinueData(type);
      //       }
      //     });
      //   } else {
      //     this.saveContinueData(type);
      //   }
    } else {
      this.saveContinueData(type);
    }
  }
  public saveContinueData(type) {
    // console.log('saveData', this.data.data);
    // console.log('this.data.modalSetting', this.data.modalSetting);
    // console.log('getCleanObject', this.getCleanObject(this.data.data));
    if (this.data.modalSetting.target === 'self') {
      if (!this.loading) {
        let validateLogic = this.validateLogic(this.data.data);
        if (!validateLogic) {
          if (this.validateObject(this.data.data)) {
            let cleanObject = this.getCleanObject(this.data.data);
            this.confirmChange(type, cleanObject);
          } else {
            this.layoutUtilsService.showNotification(this.translate.instant('You need to set all mandatory fields'), this.translate.instant('Dismiss'));
          }
        } else {
          this.layoutUtilsService.showNotification(this.translate.instant(validateLogic), this.translate.instant('Dismiss'));
        }
      }
    } else if (this.data.modalSetting.target === 'parent') {
      let validateLogic = this.validateLogic(this.data.data);
      if (!validateLogic) {
        if (this.validateObject(this.data.data)) {
          let cleanObject = this.getCleanObject(this.data.data);
          this.confirmChange(type, cleanObject);
        } else {
          this.layoutUtilsService.showNotification(this.translate.instant('You need to select all mandatory fields'), this.translate.instant('Dismiss'));
        }
      } else {
        this.layoutUtilsService.showNotification(this.translate.instant(validateLogic), this.translate.instant('Dismiss'));
      }
    }
  }
  public saveContinueDBData(type, cleanObject) {
    this.loading = true;
    //  this.loaderService.display(true);
    // let useOrgId = false;
    // if (this.data.modalSetting.hasOwnProperty('useOrgId')) {
    //   useOrgId = this.data.modalSetting['useOrgId'];
    // }
    this.errorMessage = '';
    this.requestService.saveData(this.data.dataType, cleanObject, (data, error) => {
      this.loading = false;
      if (error) {
        this.errorMessage = error;
        this.layoutUtilsService.showNotification(this.translate.instant(error), this.translate.instant('Dismiss'));
      }
      if (data) {
        if (type === 'create') {
          this.layoutUtilsService.showNotification(this.translate.instant('Created successfully'), this.translate.instant('Dismiss'));
        } else if (type === 'edit') {
          this.layoutUtilsService.showNotification(this.translate.instant('Edited successfully'), this.translate.instant('Dismiss'));
          this.sendUpdateSignal();
        }
        if (data.results && (this.data.dataType === 'user' || this.data.dataType === 'investigatorgroup' || this.data.dataType === 'camera' || this.data.dataType === 'cameragroup')) {
          let userData = data.results;
          this.returnRefresh(userData);
        } else {
          this.returnRefresh();
        }
      }
    });
  }
  returnRefresh(data = undefined) {
    if (this.data.modalSetting.refreshOrganization) {
      this.getOrgData((orgData) => {
        this.closeModal({ action: 'refresh', data });
      });
    } else {
      this.closeModal({ action: 'refresh', data });
    }
  }
  closeModal(data): void {
    if (data) {
      this.dialogRef.close(data);
    } else {
      if (this.changeOccured) {
        this.dialogRef.close({ action: 'refresh', data });
      } else {
        this.dialogRef.close(data);
      }
    }
  }
  public toggleClick(action, target, data) {
    if (target === 'parent') {
      if (this.validateObject(this.data.data)) {
        this.closeModal({ action: action, data: this.data.data, value: data });
      } else {
        this.layoutUtilsService.showNotification(this.translate.instant('You need to select all mandatory fields'), this.translate.instant('Dismiss'));
      }
    } else {
      //console.log('toggleClick Self', action, target, data);
      if (action === 'close') {
        this.closeModal(undefined);
      }
    }
  }
  private getEmptyObject() {
    let newObj = {};
    for (let col of this.data.modalSetting.fields) {
      if ((col.editable || !col.generated) && col.type !== 'action') {
        if (col.type === 'reference') {
          if (col.reference.kind === 'multiple') {
            if (col.name === 'resources' || col.name === 'role') {
              newObj[col.name] = [{ _id: '', name: '' }];
            } else {
              newObj[col.name] = [];
            }
          } else {
            newObj[col.name] = { _id: null, name: '' };
          }
        } else if (col.type === 'boolean') {
          if (col.name === 'isPasswordRequired') {
            newObj[col.name] = this.isPasswordOrgRequired;
          } else if (this.data.action === 'create-room-lobby' && (col.name === 'main' || col.name === 'emptyRoom' || col.name === 'showbg')) {
            newObj[col.name] = true;
          } else {
            newObj[col.name] = false;
          }
        } else if (col.type === 'color') {
          newObj[col.name] = '#ffffff';
        } else if (col.type === 'lnglat') {
          newObj[col.name] = undefined;
        } else if (col.type === 'picturearray') {
          newObj[col.name] = [];
        } else if (col.type === 'maparray' || col.type === 'tags') {
          newObj[col.name] = [];
        } else if (col.type === 'json') {
          newObj[col.name] = {};
        } else if (col.type === 'datetime' || col.type === 'date') {
          if (col.name === 'dob' || col.name === 'year-started') {
            newObj[col.name] = '';
          } else {
            newObj[col.name] = moment.utc().local().format('YYYY-MM-DDTHH:mm:ss');
          }
        } else if (col.type === 'number') {
          newObj[col.name] = undefined;
        } else if (col.type === 'enum') {
          if (this.data.action === 'create-room-exhibit' && col.name === 'type') {
            newObj[col.name] = '3';
          } else if (this.data.action === 'create-room-exhibit' && col.name === 'priority') {
            newObj[col.name] = 3;
          } else if (this.data.dataType === 'session' && col.name === 'attendance') {
            newObj[col.name] = 'online';
          } else {
            if (col.multiple) {
              newObj[col.name] = [];
            } else {
              newObj[col.name] = '';
            }
          }
        } else if (col.type === 'objectjson') {
          if (col.name === 'attendees' && this.data.dataType === 'event') {
            newObj[col.name] = [];
            newObj[col.name + 'Id'] = [];
          }
        } else {
          newObj[col.name] = '';
        }
        if (this.data.modalSetting.hasOwnProperty('customSettings')) {
          if (this.data.modalSetting.customSettings.hasOwnProperty(col.name) && this.data.modalSetting.customSettings[col.name].hasOwnProperty('value')) {
            let theVal = this.data.modalSetting.customSettings[col.name].value;
            if (col.type === 'objectjson') {
              if (col.name === 'attendees' && this.data.dataType === 'event') {
                let attendeesOptionsSelected = this.data.modalSetting.customSettings[col.name].options.filter((itm) => theVal.includes(itm._id));
                newObj[col.name] = attendeesOptionsSelected;
                newObj[col.name + 'Id'] = theVal;
              }
            } else {
              newObj[col.name] = theVal;
            }
          }
        }
      }
    }
    // console.log('newObj', newObj);
    return newObj;
  }
  setRuleText() {
    // console.log('this.returnData', this.returnData);
    try {
      let ruleText = this.getRecurrenceDatas(this.data.data.recurrence);
      this.ruleText = ruleText.humantext;
      this.data.data['recurrence']['all'] = ruleText.all;
      this.data.data['recurrence']['tzid'] = ruleText['tzid'];
      this.data.data['recurrence']['humantext'] = ruleText.humantext;
      this.data.data['recurrence']['localdate'] = ruleText['localdate'];
      this.data.data['recurrence']['slocaldate'] = ruleText['slocaldate'];
    } catch (e) {
      // error
      console.log('setRuleText', e);
    }
  }
  // editRecurrence() {
  //   // console.log('this.data.data.recurrence', this.data.data.recurrence);
  //   const dialogRef = this.dialog.open(RecurrenceDialogComponent, {
  //     width: '600px',
  //     data: {
  //       title: this.translate.instant('Recurrence'),
  //       data: this.data.data.recurrence || {},
  //       startdate: this.data.data.startdate,
  //       enddate: this.data.data.enddate,
  //       fields: this.metaFieldSetting['recurrence'].fields,
  //       overWrite: this.metaFieldSetting['overWrite'],
  //     }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       // let startdate = new Date(this.data.data.startdate);
  //       // let startdateUTC = new Date(Date.UTC(startdate.getFullYear(), startdate.getMonth(), startdate.getDate(), startdate.getHours(), startdate.getMinutes(), 0));
  //       // result['startdate'] = startdateUTC; // added this to make sure we always use the start date from event
  //       // let dtstart = moment(this.data.data.startdate).utc().toDate();
  //       // dtstart.setMinutes(dtstart.getMinutes() - dtstart.getTimezoneOffset());
  //       result['startdate'] = moment(this.data.data.startdate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

  //       this.data.data['recurrence'] = result;
  //       this.setRuleText();
  //     }
  //   });
  // }
  confirmChange(type, cleanObject) {
    if (this.data.dataType === 'event' && type === 'edit' && this.data.data['eventType'] !== 'blueprint') {
      let ruleOriginalText = '';
      let ruleText = '';
      try {
        ruleOriginalText = this.getRecurrenceDatas(this.originalData.recurrence).humantext;
        ruleText = this.getRecurrenceDatas(this.data.data.recurrence).humantext;
      } catch (e) {
        // console.log(e);
      }
      let isRecurrenceOriginal = this.originalData.isRecurrence;
      let isRecurrence = this.data.data.isRecurrence;
      if (ruleOriginalText !== ruleText || (isRecurrenceOriginal === true && isRecurrence === false) || (isRecurrence && (moment(this.originalData.startdate).diff(moment(this.data.data.startdate), 'minutes') != 0 || moment(this.originalData.enddate).diff(moment(this.data.data.enddate), 'minutes') != 0))) {
        let mainMsg = 'You are changing the recurrence of the current event. How do you want to proceed?';
        let confirmBtn = 'Deleting future events and creating a new event';
        let declineBtn = 'Keeping existing events and creating a new event';
        this.handleConfirmChangeModal(mainMsg, confirmBtn, declineBtn, (callbackStatus) => {
          if (callbackStatus !== undefined) {
            if (callbackStatus === true) {
              cleanObject['overWrite'] = '1';
            } else if (callbackStatus === false) {
              cleanObject['overWrite'] = '3';
            }
            if (this.data.modalSetting.target === 'self') {
              this.saveContinueDBData(type, cleanObject);
            } else if (this.data.modalSetting.target === 'parent') {
              this.closeModal({ action: type, dataType: this.data.dataType, dataTypeTitle: this.data.dataTypeSingleTitle, modalSetting: this.data.modalSetting, data: cleanObject });
            }
          }
        });
      } else {
        if (this.data.modalSetting.target === 'self') {
          this.saveContinueDBData(type, cleanObject);
        } else if (this.data.modalSetting.target === 'parent') {
          this.closeModal({ action: type, dataType: this.data.dataType, dataTypeTitle: this.data.dataTypeSingleTitle, modalSetting: this.data.modalSetting, data: cleanObject });
        }
      }
    } else {
      if (this.data.modalSetting.target === 'self') {
        this.saveContinueDBData(type, cleanObject);
      } else if (this.data.modalSetting.target === 'parent') {
        this.closeModal({ action: type, dataType: this.data.dataType, dataTypeTitle: this.data.dataTypeSingleTitle, modalSetting: this.data.modalSetting, data: cleanObject });
      }
    }
  }
  private handleConfirmChangeModal(mainMsg: string, confirmBtn: string, declineBtn: string, callback: (dataResponse: boolean) => void, smallMsg: string = undefined) {
    let alertSetting = {};
    alertSetting['overlayClickToClose'] = false;
    alertSetting['showCloseButton'] = true;
    alertSetting['smallMsg'] = smallMsg;
    alertSetting['confirmText'] = confirmBtn;
    alertSetting['declineText'] = declineBtn;

    const dialogRef = this.layoutUtilsService.alertActionElement(this.translate.instant('Confirm Changes'), this.translate.instant(mainMsg), alertSetting);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.action === 'confirmText') {
          callback(true);
        } else if (result.action === 'declineText') {
          callback(false);
        }
      } else {
        callback(undefined);
      }
    });
  }
  private isUrlValid(url: string): boolean {
    const re = /^(?:(rtsp):\/\/[a-zA-Z0-9._-]+:[^@]+@(?:\d{1,3}\.){3}\d{1,3}:\d+\/[\w\/.-]+|(https?|rtmp):\/\/(?:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|(?:\d{1,3}\.){3}\d{1,3})(:\d+)?(\/[\w\-./?%&=]*)?)$/i;
    return re.test(url.trim());
  }
  private isEmailValid(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  public addPictures(id, url) {
    if (this.data.data.hasOwnProperty(id)) {
      this.data.data[id].push({ url: url, type: 'link', link: "", thumbnail: getOtherImage('', url, '_thumbnail') });
    } else {
      this.data.data[id] = [{ url: url, type: 'link', link: "", thumbnail: getOtherImage('', url, '_thumbnail') }];
    }
  }
  public setPictureArrayType(idx, id, val) {
    this.data.data[id][idx]['type'] = val;
    this.data.data[id][idx]['link'] = '';
    this.data.data[id][idx]['linkDisplay'] = '';
  }
  public setMapArrayType(idx, id, val) {
    this.data.data[id][idx]['type'] = val;
    this.data.data[id][idx]['link'] = '';
  }
  public setMapArrayShape(idx, id, val) {
    this.data.data[id][idx]['shape'] = val;
  }
  public selectPictureLinkType(idx, id, type) {
    if (type === 'tile') {
      // this.editTile(idx, id);
    } else if (type === 'room') {
      this.editCustomSelectDialog('room', 'Room', idx, id);
    }
  }
  editCustomSelectDialog(dataType, dataTypeTitle, idx, id) {
    let filterData: any = {
      '$and': [
        { 'organizationId._id': { '$eq': this.requestService.orgId } }
      ]
    };
    const dialogRef = this.dialog.open(CustomSelectDialogComponent, {
      autoFocus: false,
      width: '600px',
      data: {
        title: this.translate.instant('Select') + ' ' + this.translate.instant('Room'),
        dataType: dataType,
        dataTypeTitle: dataTypeTitle,
        filters: filterData,
        data: this.data.data[id][idx]['link'],
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.hasOwnProperty('_id')) {
          this.data.data[id][idx]['link'] = result['_id'];
          this.data.data[id][idx]['linkDisplay'] = result['text'];
        } else {
          this.data.data[id][idx]['link'] = '';
          this.data.data[id][idx]['linkDisplay'] = '';
        }
      }
    });
  }
  public addArrayMapOption(id) {
    if (!this.data.data.hasOwnProperty(id)) {
      this.data.data[id] = [];
    }
    this.data.data[id].push({ coords: '', shape: 'rect', type: 'link', link: '', title: 'New Title', target: '_blank' });

  }
  public deleteArrayMap(id, index) {
    this.data.data[id].splice(index, 1);
  }
  public deletePictures(id, index) {
    this.data.data[id].splice(index, 1);
  }

  editPictureWallImages($event, id) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    const dialogRef = this.dialog.open(ModalGalleryDialogComponent, {
      width: '1600px',
      disableClose: false,
      autoFocus: false,
      data: {
        title: this.translate.instant('Edit Billboard Images Uploaded'),
        galleryType: this.data.dataType + '-' + id + '-art',
        targetId: this.requestService.orgId,
        data: [],
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (Array.isArray(result)) {
          for (let itm of result) {
            this.addPictures(id, itm.imageUrl);
          }
        } else {
          this.addPictures(id, result);
        }
        // do nothing
      }
    });
  }
  /**
  *  @param target: trigger event
  *
  *  trigger read files browsed files
  */
  onBrowseFiles(id, target: any): void {
    // this.readFiles(id, target.files);
    // if (target.files.length > 1) {
    // const dialogRef = this.dialog.open(MultipleModalDialogComponent, {
    //   width: '100vw',
    //   disableClose: false,
    //   autoFocus: false,
    //   data: {
    //     title: this.translate.instant('Multiple') + ' ' + this.translate.instant('Images') + ' ' + this.translate.instant('Upload'),
    //     path: 'banner/image/upload/' + this.requestService.orgId,
    //     target: target,
    //     allowedExtensions: this.allowedExtensions,
    //     allowedAcceptExtensions: this.allowedAcceptExtensions,
    //     isImageUpload: true,
    //     addName: true
    //   }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (this.fileselect) {
    //     this.fileselect.nativeElement.value = "";
    //   }
    //   if (result) {
    //     console.log(result);
    //     for (let itm of result) {
    //       this.addPictures(id, itm.uploaded.link);
    //     }
    //   }
    // });
    // } else {
    // 	this.readFiles(id, target.files);
    // }
  }

  /**
   *  @param files: list of browsed files
   *  @param index: iterator over browsed images
   *
   *  read files browsed by user
   */
  readFiles(id, files, index = 0): void {
    // let reader = new FileReader();
    if (index in files) {
      let currentFile = { error: false, text: files[index].name, id: files[index].id, originalFile: files[index], source_url: null, extension: '' };
      let fileExt = files[index].name.split('.').pop();
      currentFile.extension = fileExt.toLowerCase();
      // this.imageExtension = fileExt.toLowerCase();
      const max_size = 5000000;
      if (files[index].size > max_size) {
        this.layoutUtilsService.showNotification(this.translate.instant('Maximum size allowed is') + ' ' + max_size / 1000000 + 'MB', this.translate.instant('Dismiss'));
      } else if (this.allowedExtensions.indexOf(fileExt.toLowerCase()) === -1) {
        currentFile.error = true;
      } else {
        this.loaderService.display(true);
        // this.requestService.onUploadPictureByBanner(currentFile)
        //   .subscribe(
        //     (results: any) => {
        //       //console.log('results', results);
        //       if (results['status']) {
        //         currentFile.source_url = results['results'].link;
        //         this.addPictures(id, results['results'].link);
        //         this.layoutUtilsService.showNotification(this.translate.instant('Successfully Uploaded'), this.translate.instant('Dismiss'));
        //       } else {
        //         currentFile.error = true;
        //         this.layoutUtilsService.showNotification(results['message'], this.translate.instant('Dismiss'));
        //       }
        //       // this.myInputVariable.nativeElement.value = "";
        //       this.loaderService.display(false);
        //       this.changeDetectorRefs.detectChanges();
        //       // this.currentFile = currentFile;
        //     },
        //     error => {
        //       //console.log('Error uploading file.', error);
        //       this.loaderService.display(false);
        //       currentFile.error = true;
        //       this.layoutUtilsService.showNotification(this.translate.instant('Error uploading file.'), this.translate.instant('Dismiss'));
        //       this.changeDetectorRefs.detectChanges();
        //     }
        //   );
      }
    } else {
      this.changeDetectorRefs.detectChanges();
    }
    if (this.fileselect) {
      this.fileselect.nativeElement.value = "";
    }

  }
  readFile(file, reader, callback): void {
    reader.onload = () => {
      callback(reader.result);
    }
    reader.readAsDataURL(file);
  }
  getRecurrenceDatas(recurObj) {
    let response = { humantext: '', all: undefined, rule: undefined };
    if (!recurObj) {
      return response;
    } else {
      let pattern = "";
      let patternView = "";
      let count = 0;
      switch (recurObj["repeats"]) {
        case "minutely":
          pattern = "FREQ=MINUTELY;INTERVAL=" + recurObj["interval"];
          break;
        case "hourly":
          pattern = "FREQ=HOURLY;INTERVAL=" + recurObj["interval"];
          break;
        case "daily":
          pattern = "FREQ=DAILY;INTERVAL=" + recurObj["interval"];
          break;
        case "weekly":
          pattern = "FREQ=WEEKLY;INTERVAL=" + recurObj["interval"] + ";BYDAY=" + recurObj["byweekday"].toString();
          break;
        case "monthly":
          pattern = "FREQ=MONTHLY;INTERVAL=" + recurObj["interval"];
          if (recurObj["monthlyType"] && recurObj["monthlyType"] == "dayofmonth") {
            pattern += ";BYMONTHDAY=" + recurObj["bymonthday"].toString();
          } else {
            pattern += ";BYSETPOS=" + recurObj["bysetpos"] + ";BYDAY=+" + recurObj["bysetpos"] + recurObj["byday"].toString();
          }
          break;
        case "yearly":
          pattern = "FREQ=YEARLY;"
          if (recurObj["yearlyType"] && recurObj["yearlyType"] == "dayofmonth") {
            pattern += "BYMONTH=" + recurObj["bymonth"] + ";BYMONTHDAY=" + recurObj["bymonthday"].toString();
          } else {
            pattern += "BYDAY=+" + recurObj["bysetpos"] + recurObj["byday"] + ";BYSETPOS=" + recurObj["bysetpos"] + ";BYMONTH=" + recurObj["bymonth"].toString();
          }
          break;
        default:
          pattern = "";
      }
      patternView = pattern;
      if (recurObj["end"] && recurObj["end"] == "after") {
        pattern += ";COUNT=" + recurObj["count"];
        patternView += ";COUNT=" + recurObj["count"];
        count = recurObj["count"];
      }
      if (recurObj["tzid"]) {
        pattern += ";TZID=" + recurObj["tzid"];
      } else {
        pattern += ";TZID=" + this.getUserTimeZone();
      }
      if (recurObj["end"] && recurObj["end"] == "date") {
        pattern += ";UNTIL=" + moment(recurObj["until"]).format('YYYYMMDDTHHmmss');
        patternView += ";UNTIL=" + moment(recurObj["until"]).format('YYYYMMDDTHHmmss');
      }
      // console.log('pattern', pattern);
      let options = rrule.RRule.parseString(pattern);
      let optionsView = rrule.RRule.parseString(patternView);
      let startdate = new Date(recurObj["startdate"]);
      const utcStartDate = new Date(startdate.getTime() - startdate.getTimezoneOffset() * 60000);
      const utcMoment = moment.utc(recurObj["startdate"]);
      const localMoment = utcMoment.local();
      const formattedLocalTime = localMoment.format('YYYY-MM-DD hh:mm A');
      options.dtstart = utcStartDate;
      optionsView.dtstart = utcStartDate;
      if (count && count != 0) {
        options.count = count;
        optionsView.count = count;
      } else {
        // options.until = new Date(recurObj["until"]);
        //options.until = moment(recurObj['until']).utc().toDate();
        //optionsView.until = moment(recurObj['until']).toDate();
      }
      if (recurObj["tzid"]) {
        options.tzid = recurObj["tzid"];
      } else {
        options.tzid = this.getUserTimeZone();
      }
      var rule = new rrule.RRule(options);
      var ruleView = new rrule.RRule(optionsView);
      // return rule.toText();
      // var all = rule.all();
      response["tzid"] = recurObj["tzid"];
      response["localdate"] = utcStartDate;
      response["slocaldate"] = formattedLocalTime;
      response["humantext"] = ruleView.toText();
      // response["rule"] = rule;
      // response["all"] = all.map((occurrence: Date) => {
      //   occurrence = new Date(occurrence.getTime() + occurrence.getTimezoneOffset() * 60000);
      //   return occurrence;
      // });
    }
    return response;
  };

  getUserTimeZone() {
    // Create a new date object with the current date and time
    const now = new Date();

    // Get the time zone from the date object using the Intl.DateTimeFormat API
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return timeZone;
  }

  markerMapSelect(id, mark: any) {
    this.data.data[id] = JSON.stringify(mark);
    // this.currentDialogMap.setPin(mark);
  }
  addressPinData(id, address: any) {
    if (id === 'geolocation' && (this.data.dataType === 'case' || this.data.dataType === 'camera')) {
      this.data.data['address'] = address;
    }
  }
  addressJPPinData(id, address: any) {
    if (id === 'geolocation' && (this.data.dataType === 'case' || this.data.dataType === 'camera')) {
      this.data.data['address_jp'] = address;
    }
  }
  // createRTMPUrl() {
  //   let rtmpObj = {
  //     name: this.data.data['name'],
  //     type: 'liveStream',
  //     streamId: this.data.data['name'],
  //     publishType: "WebRTC",
  //     publish: true,
  //     publicStream: true
  //   }
  //   // call an api posting this object to create a new rtmp url
  //   this.requestService.postRequest('camera/broadcast', 'create', rtmpObj, (data, error) => {
  //     if (error) {
  //       this.layoutUtilsService.showNotification(this.translate.instant('Error creating Live Stream URL') + ' ' + error, this.translate.instant('Dismiss'));
  //     }
  //     if (data) {
  //       if (data.status) {
  //         // get the correct feilds from udhay
  //         this.data.data['stream_url'] = data.results.stream_url;
  //         this.data.data['target_url'] = data.results.target_url;
  //         this.layoutUtilsService.showNotification(this.translate.instant('Live Stream URL created successfully'), this.translate.instant('Dismiss'));
  //       } else {
  //         this.layoutUtilsService.showNotification(data.message, this.translate.instant('Dismiss'));
  //       }
  //     }
  //   });
  // }
  searchAddress($event, id) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (id === 'address' || id === 'address_jp') {
      if (id === 'address') {
        this.data.data['address_jp'] = this.data.data['address']
      }
      if (id === 'address_jp') {
        this.data.data['address'] = this.data.data['address_jp']
      }
      if (this.data.data[id] && this.data.data[id] !== '') {
        this.dialogMap.searchByText(this.data.data[id]);
      }
    }
  }
  async rotateImages() {
    for (const degree of this.baseImageGeoSetDegrees) {
      await this.rotateImage(degree);
    }
  }

  private rotateImage(degree: number): Promise<void> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = this.baseImageGeo;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // Set the canvas dimensions based on the rotated image
        canvas.width = img.height;
        canvas.height = img.width;

        // Rotate the image
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(-degree * (Math.PI / 180));
        ctx.drawImage(img, -img.width / 2, -img.height / 2);

        // Convert the rotated image back to base64

        this.baseImageGeoSet[degree] = canvas.toDataURL('image/png');
        // console.log(degree, this.baseImageSet[degree]);
        resolve();
      };
    });
  }
  print(caseId) {
    let url = '/case-print/' + caseId;
    openCenteredPopup(url, this.translate.instant('Case Print'));
  }
  clearLocation() {
    this.data.data['geolocation'] = undefined;
    this.data.data['address'] = '';
    this.data.data['address_jp'] = '';
    this.data.data['rotation_start_at'] = 0;
    this.data.data['rotation_end_at'] = 0;
    this.data.data['shape_length'] = 0;
    this.data.data['camera_field_view_color'] = 'red';
    if (this.dialogMap) {
      this.dialogMap.clearLocationMarker();
    }
  }
  sendUpdateSignal(): void {
    if (this.data.dataType === 'camera') {
      this.sendCameraUpdateSignal();
    }
  }
  sendCameraUpdateSignal(): void {
    this.signalingService.publish(
      "case-all", {
      type: 'camera-updated',
      cameraId: this.data.data['_id'],
    },
      this.signalingService.camerasTopicName
    );
  }
}
